import React, { useEffect, useState } from "react";
import { useCounter } from "../../Helpers/useCounter";
import CabezoteComponent from "../../Components/Cabezote/cabezote.component";
import arrowleft from "../../assets/icons/left.svg";
import arrowrigth from "../../assets/icons/rigth.svg";
import axios from "axios";
import { GETPRODUCTO } from "../../global/const";
import Relacionados from "../../Components/CardProducto/gridProductos.component";
import Footer from "../../Components/Footer/Footer.components";
import * as constant from "../../global/const";
import { useSelector } from "react-redux";
// import Retornable from '../../assets/icons/Retornable.svg'
// import time from '../../assets/icons/time.svg'
import OfertaIcon from "../../assets/icons/Oferta.svg";
import Loader from "react-loader-spinner";
import auth from "../../Helpers/auth";

//texto enriquecido
import { Markup } from "interweave";

//imagenes
import { Alerta } from "../Cabezote/alerta.component";
import noimage from "../../assets/icons/elementosA.svg";
import { Redemption } from "../Checkout/Redencion/Redemption.page";

var box = {
  border: "2px solid #0075bb",
};

const DetalleProducto = (props) => {
  const carritoRedux = useSelector((state) => state.carrito.carrito);
  let user = JSON.parse(auth.getUsuario());
  var _carrito = JSON.parse(localStorage.getItem(constant.CARRITO)) || {};
  const categories = useSelector((state) => state.categories);
  // let _carritoPromos = JSON.parse(localStorage.getItem(constant.CARRITOPROMO)) || {};

  const [productoDetalle, setProductoDetalle] = useState();
  const [agotado, setAgotado] = useState(false);
  const [sinImagen, setSinImagen] = useState(false);
  const [mostrarOpciones, setMostrarOpciones] = useState(false);

  //const producto = props.producto;
  const sucursal = useSelector((state) => state.page.sucursal);
  const [mensaje, setMensaje] = useState("");
  const [showMessage, setshowMessage] = useState(false);
  const [showModalRedemption, setShowModalRedemption] = useState(false);
  const [currentValue, setCurrentValue] = useState(undefined);

  const {
    counter,
    getTotalAmount,
    setCounter,
    prueba,
    handleSubmitAddValidate,
    handleSubmitSubtractValidate,
  } = useCounter(
    _carrito[
      "-" +
        props.match.params.producto.split("-")[
          props.match.params.producto.split("-").length - 1
        ]
    ]
      ? _carrito[
          "-" +
            props.match.params.producto.split("-")[
              props.match.params.producto.split("-").length - 1
            ]
        ].cantidad
      : 0,
    setMensaje,
    setshowMessage,
    setShowModalRedemption
  );

  const [open, setOpen] = useState(false);
  const [close, setclose] = useState(true);
  const [codigoSku, setCodigoSku] = useState("");
  const [precioProducto, setprecioProducto] = useState("");
  const [nombreProducto, setnombreProducto] = useState("");
  const [Error, setError] = useState(false);
  const [retornable, setretornable] = useState("");
  const [oferta, setoferta] = useState("");
  const [descripcion, setdescripcion] = useState("");
  const [imagenCurrent, setimagenCurrent] = useState("");
  const [presentacion, setpresentacion] = useState("");
  const [vin, setvin] = useState("");
  const [imagens, setimagens] = useState("");
  const [categoria, setcategoria] = useState("");
  const [nombreCategoria, setnombreCategoria] = useState("");
  const [nombreMarca, setnombreMarca] = useState("");
  // const [principales, setPrincipales] = useState([]);
  // const [itemSelected, setItemSelected] = useState("");
  const [promocion, setPromocion] = useState([]);
  const [promocionRedime, setPromocionRedime] = useState([]);

  const [loader, setLoader] = useState(true);
  let { history } = props;

  const handleSubtract = () => {
    handleSubmitSubtractValidate(productoDetalle);
  };

  const handleInputBlur = (value) => {
    setCurrentValue(undefined);
    let valorNumerico = parseFloat(value);

    // Validar que no exceda 8000
    if (!isNaN(valorNumerico) && valorNumerico > 8000) {
      valorNumerico = 8000;
    }
  
    prueba(productoDetalle, valorNumerico);  
  };

  const handleInputChange = (value) => {
    // Regex para 4 dígitos, con opción de .5 si permite media
    let reg = /^(\d{0,4})(\.[5]{1})?$/gm;
    if (productoDetalle.permiteMedia != 1) {
      reg = /^(\d{0,4})?$/gm;
    }
    
    if (!isNaN(value) && reg.test(value) && value.length <= 4) {
      // Validar que el valor no exceda 8000
      const valorNumerico = parseFloat(value);
      if (!isNaN(valorNumerico) && valorNumerico > 8000) {
        setCurrentValue('8000');
        return;
      }
      setCurrentValue(value);
      return;
    }
    
    if (value === '') {
      setCurrentValue('');
      return;
    }
  };

  const handleAdd = () => {
    handleSubmitAddValidate(productoDetalle);
  };

  var cent = false;

  useEffect(() => {
    if (props.match.params.producto && sucursal != null && categories.length) {
      var urlProduct = props.match.params.producto;
      var productArray = urlProduct.split("-");
      var producCodigoSku = productArray[productArray.length - 1];

      if (carritoRedux["-" + producCodigoSku]) {
        setCounter(carritoRedux["-" + producCodigoSku].cantidad);
      } else {
        setCounter(0);
      }
      getTotalAmount();
      getProducto(producCodigoSku);
    }
  }, [sucursal, categories]);

  const getProducto = (codigoSku) => {
    axios
      .get(
        GETPRODUCTO +
          `?nit=${sucursal.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&codigoSku=${codigoSku}&correo=${user.email}`
      )
      .then((res) => {
        if (Object.entries(res.data).length === 0) {
          setError(true);
          return;
        }
        setProductoDetalle(res.data);
        let producto = res.data;
        const a = producto.promocion.filter(
          (promo) => promo.tipoDescuento == 1
        );
        const b = producto.promocionRedime.filter(
          (promoR) => promoR.tipoDescuento == 5
        );
        setAgotado(producto.agotado == 1 ? true : false);
        setCodigoSku(producto.codigoSku);
        setprecioProducto(a.length ? a[0].precio : producto.precio);
        setnombreProducto(producto.nombre);
        setretornable(producto.retornable);
        setoferta(producto.oferta);
        setdescripcion(producto.descripcion);
        setpresentacion(producto.presentacionNombre);
        setvin(producto.vinetas);
        setimagenCurrent({
          id: 1,
          url: `${constant.URL_BASE_IMAGES}image/${producto.codigoSku}.jpg`,
        });
        producto.imagenes.push({ id: 1, nombre: producto.codigoSku + ".jpg" });
        setimagens(producto.imagenes);
        setnombreCategoria(producto.categoriaNombre);
        setnombreMarca(producto.marcaNombre);
        setLoader(false);

        setPromocion(a);
        setPromocionRedime(b);
        // setPromocion(...aux);
        // setPromocionRedime(...aux2);
      })
      .catch((error) => {
        setError(true);
      });
  };

  const ChangeImage = (imagen) => {
    if (imagen.id === 1) {
      setimagenCurrent({
        id: imagen.id,
        url: `${constant.URL_BASE_IMAGES}image/${imagen.nombre}`,
      });
    } else {
      setimagenCurrent({
        id: imagen.id,
        url: `${constant.URL_BASE_IMAGES}listaImagenes/${codigoSku}/${imagen.nombre}`,
      });
    }
  };

  const slider = (rigth) => {
    if (rigth) {
      const arraySearch = Array.from(imagens);
      var index = arraySearch.findIndex((e) => e.id === imagenCurrent.id);
      if (index === imagens.length - 1) {
        if (imagens[0].id === 1) {
          setimagenCurrent({
            id: imagens[0].id,
            url: `${constant.URL_BASE_IMAGES}image/${imagens[0].nombre}`,
          });
        } else {
          setimagenCurrent({
            id: imagens[0].id,
            url: `${constant.URL_BASE_IMAGES}listaImagenes/${codigoSku}/${imagens[0].nombre}`,
          });
        }
      } else {
        if (imagens[index + 1].id === 1) {
          setimagenCurrent({
            id: imagens[index + 1].id,
            url: `${constant.URL_BASE_IMAGES}image/${
              imagens[index + 1].nombre
            }`,
          });
        } else {
          setimagenCurrent({
            id: imagens[index + 1].id,
            url: `${constant.URL_BASE_IMAGES}listaImagenes/${codigoSku}/${
              imagens[index + 1].nombre
            }`,
          });
        }
      }
    } else {
      const arraySearch = Array.from(imagens);
      var index = arraySearch.findIndex((e) => e.id === imagenCurrent.id);
      if (index === 0) {
        if (imagens[imagens.length - 1].id === 1) {
          setimagenCurrent({
            id: imagens[imagens.length - 1].id,
            url: `${constant.URL_BASE_IMAGES}image/${
              imagens[imagens.length - 1].nombre
            }`,
          });
        } else {
          setimagenCurrent({
            id: imagens[imagens.length - 1].id,
            url: `${constant.URL_BASE_IMAGES}listaImagenes/${codigoSku}/${
              imagens[imagens.length - 1].nombre
            }`,
          });
        }
      } else {
        if (imagens[index - 1].id === 1) {
          setimagenCurrent({
            id: imagens[index - 1].id,
            url: `${constant.URL_BASE_IMAGES}image/${
              imagens[index - 1].nombre
            }`,
          });
        } else {
          setimagenCurrent({
            id: imagens[index - 1].id,
            url: `${constant.URL_BASE_IMAGES}listaImagenes/${codigoSku}/${
              imagens[index - 1].nombre
            }`,
          });
        }
      }
    }
  };

  return (
    <div className="home">
      {showMessage && (
        <Alerta
          history={history}
          mensaje={mensaje}
          show={showMessage}
          setShow={setshowMessage}
          setShowModalRedemption={setShowModalRedemption}
          tipo={0}
        />
      )}
      {showModalRedemption && (
        <Redemption
          codigoSku={mensaje.split("-")[1]}
          setShowModalRedemption={setShowModalRedemption}
        />
      )}
      <CabezoteComponent
        open={open}
        setOpen={setOpen}
        tipo={false}
        categoriasGlobal={null}
        close={close}
        setclose={setclose}
        mostrarOpciones={mostrarOpciones}
        setMostrarOpciones={setMostrarOpciones}
      />
      {!Error ? (
        <>
          {!loader ? (
            <div className="detalleProducto">
              <div className="volver">
                <div className="migaPan">
                  <i className="fas fa-sliders"></i>{" "}
                  <h7>
                    {" "}
                    {nombreCategoria} / {nombreMarca}/{" "}
                  </h7>
                  <span>{nombreProducto}</span>
                </div>

                <button
                  className="volv"
                  onClick={() => {
                    cent = true;
                    window.history.back();
                  }}
                >
                  Volver al catálogo
                </button>
              </div>
              <div className="body-detalle">
                <div className="media">
                  <div className="detalleVineta">
                    {vin
                      ? vin.map((vineta) => {
                          return (
                            <div
                              key={vineta.nombre}
                              className="vineta"
                              style={{
                                backgroundColor: vineta.color + "8c",
                                border: vineta.colorTexto + " 1px solid",
                                color: vineta.colorTexto,
                              }}
                            >
                              <div>
                                <span
                                  style={{
                                    backgroundColor: vineta.colorTexto,
                                    color: vineta.colorTexto,
                                  }}
                                >
                                  ..
                                </span>
                              </div>
                              <p>{vineta.texto}</p>
                            </div>
                          );
                        })
                      : null}
                  </div>
                  <div className="imagenProducto">
                    {/* <img src={temp} alt="" className="foto" /> */}
                    <img
                      src={imagenCurrent.url + "?" + Math.random()}
                      className="foto"
                      alt="Not Found"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noimage;
                        setSinImagen(true);
                      }}
                      style={{
                        opacity: agotado ? ".5" : "1",
                      }}
                    />
                    {sinImagen && (
                      <div className="imagenProducto-SinImagen">
                        <div className="imagenProducto-SinImagen-cajaTexto">
                          <p>Imagen No Disponible</p>
                        </div>
                      </div>
                    )}
                    {agotado && (
                      <div className="imagenProducto-agotado">
                        <div className="imagenProducto-agotado-cajaTexto">
                          <p>AGOTADO</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="relacionados">
                    <div>
                      <div
                        onClick={() => slider(false)}
                        className="arrow-content arrow-left"
                      >
                        <img className="arrow" src={arrowleft} alt="" />
                      </div>
                      <div className="imagenes">
                        {imagens
                          ? imagens.map((imagenes) => {
                              return (
                                <>
                                  {imagenes.id === 1 ? (
                                    <div
                                      onClick={() => ChangeImage(imagenes)}
                                      key={imagenes.id}
                                      className="imagen"
                                    >
                                      <img
                                        style={
                                          imagenCurrent.id === imagenes.id
                                            ? box
                                            : null
                                        }
                                        src={`${
                                          constant.URL_BASE_IMAGES
                                        }image/${
                                          imagenes.nombre
                                        }?${Math.random()}`}
                                        alt=""
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      onClick={() => ChangeImage(imagenes)}
                                      key={imagenes.id}
                                      className="imagen"
                                    >
                                      <img
                                        style={
                                          imagenCurrent.id === imagenes.id
                                            ? box
                                            : null
                                        }
                                        src={`${
                                          constant.URL_BASE_IMAGES
                                        }listaImagenes/${codigoSku}/${
                                          imagenes.nombre
                                        }?${Math.random()}`}
                                        alt=""
                                      />
                                    </div>
                                  )}
                                </>
                              );
                            })
                          : null}
                        {/* <img src="https://www.latinfoodsmarket.com/img-LFM_MainProductImage_392.jpg" alt="" />
                                                <img src="https://i0.wp.com/mercaenlinea.nyc3.digitaloceanspaces.com/2019/01/gaseosa_postobon_manzana_2l.jpg?fit=1000%2C1000&ssl=1" alt="" />
                                                <img src={`${constant.URL_BASE}image/${codigoSku}.png`} alt="" /> */}
                      </div>
                      <div
                        onClick={() => slider(true)}
                        className="arrow-content arrow-rigth"
                      >
                        <img className="arrow" src={arrowrigth} alt="" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="textoProducto">
                  <div className="nombreProducto">
                    <h2 className="nombre">
                      {" "}
                      {nombreProducto} {presentacion}
                    </h2>
                  </div>
                  <div className="description">
                    {<Markup content={descripcion} />}
                  </div>
                  <hr className="section" />

                  <div className="item">
                    <div className="list-items">
                      {promocion.length > 0 || promocionRedime.length > 0 ? (
                        <img className="icon-oferta" src={OfertaIcon} alt="" />
                      ) : null}
                      <p style={{ backgroundColor: "#ffe194" }}>
                        {promocion.length > 0
                          ? promocion[0].textoDescuento
                          : promocionRedime.length > 0
                          ? promocionRedime[0].textoDescuento
                          : ""}
                      </p>
                    </div>

                    <span>
                      {promocion.length > 0 ? (
                        promocion[0].textoDescuentoDetalle
                      ) : promocionRedime.length > 0 &&
                        promocionRedime[0].tipoIntegracion == 1 ? (
                        <React.Fragment>
                          <b>Por la compra de:</b>
                          <ul>
                            {promocionRedime[0].productosBase.map((item) => (
                              <li>
                                {item.cantidad + " caja(s) de " + item.nombre}
                              </li>
                            ))}
                          </ul>
                          <b>Te obsequiamos:</b>
                          <ul>
                            {promocionRedime[0].productosPromo.map((item) => (
                              <li>
                                {item.cantidad +
                                  " unidad(es) de " +
                                  item.nombre}
                              </li>
                            ))}
                          </ul>
                        </React.Fragment>
                      ) : (
                        promocionRedime.length > 0 &&
                        promocionRedime[0].textoDescuentoDetalle
                      )}
                    </span>
                  </div>
                  <hr className="section" />

                  <div className="prueba">
                    <div className="precioProducto">
                      {
                        // valor quemado
                        //<del className="regular"> Precio Regular $ 35000</del>
                      }
                      <h4 className="ahora">
                        {" "}
                        Precio{" "}
                        {" $" +
                          new Intl.NumberFormat("de-DE", {
                            numberingSystem: "latn",
                            style: "decimal",
                            currency: "COP",
                          }).format(precioProducto)}
                      </h4>
                    </div>

                    <div
                      className={"cantidadProducto " + (agotado && "agotado")}
                    >
                      <div className="contadorProducto producto">
                        <i
                          className="fa fa-plus-circle"
                          aria-hidden="true"
                          onClick={() => {
                            handleAdd();
                          }}
                        ></i>
                        {/* <p>{counter}</p> */}
                        <input
                          className="digitacion"
                          onFocus={(e) => e.target.select()}
                          onBlur={(e) => handleInputBlur(e.target.value)}
                          /* value={counter} */
                          onChange={(e) => handleInputChange(e.target.value)}
                          value={currentValue ?? counter}
                        />
                        <i
                          className="fa fa-minus-circle"
                          aria-hidden="true"
                          disabled={false}
                          onClick={() => {
                            handleSubtract();
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                  <hr className="section" />

                  <div className="botones">
                    <div className="comprar">
                      <button
                        className="compra"
                        onClick={() => {
                          window.location.href =
                            "./Catalogo/Categoria/-1/Todos/1";
                        }}
                      >
                        {" "}
                        Seguir comprando
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="seguirComprando"></div>
            </div>
          ) : (
            <div className="loader_centerPages">
              <Loader
                type="ThreeDots"
                color="#0075BB"
                height={100}
                width={100}
              />
            </div>
          )}
        </>
      ) : (
        <div className="ErrorContent">
          <h1 className="errorMedage">Hubo un error al consultar los datos</h1>
        </div>
      )}
      <div className="productosRelacionados">
        <h2 className="t"> Productos recomendados</h2>
        <Relacionados tipo={3} />
        <div className="boton">
          <button
            className="todosRelacionados"
            onClick={() => {
              history.push("/Catalogo/Categoria/-4/Todos/1");
            }}
          >
            Ver productos en oferta
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DetalleProducto;
